module.exports = __webpack_public_path__ + "static/media/mailchimp-dark.8e846d88.png";